import React, { useContext, useState } from "react";
import axios from 'axios';

import { useNavigate } from 'react-router-dom';

import PhoneNumberConfirmationForm from '../../components/Forms/PhoneNumber/PhoneNumberConfirmationForm'

import useSetPageTitle from "../../hooks/useSetPageTitle";
import UserContext from "contexts/UserContext";

function ForgotEmail() {
    const { currentPromo } = useContext(UserContext);
    useSetPageTitle('Esqueci meu email', currentPromo);
    
    const navigate = useNavigate();
    const [doc, setDoc] = useState('');
    const [docWarning, setDocWarning] = useState('');
    const [loading, setLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [retrievedEmail, setRetrievedEmail] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');

    console.log("Estado retrievedEmail:", retrievedEmail);

    return (
        <div className="forgot-email-page-container">
            <PhoneNumberConfirmationForm
                loading={loading}
                phoneNumber={phoneNumber}
            />
            {errorMessage && (
                <div className="forgot-email-error-message">
                    <p>{errorMessage}</p>
                </div>
            )}
        </div>
    );
}

export default ForgotEmail;
